export default __webpack_public_path__ + "locales/ru/PDFFormDialog.json?hash=eadb6668af544aaba568eea9cfb9cb37";